<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('OBJET_METIER_LIST')">
        <slot name="section-objet-metier-list">
          <section-objet-metier-list ref="OBJET_METIER_LIST"
                                     id="OBJET_METIER_LIST"
                                     :extended="isExtended('OBJET_METIER_LIST')"
                                     :showButton="true"
                                     :autoSave="true"
                                     :readOnly="readOnly"
                                     :moduleId="moduleId"
                                     :searchText="searchText"
                                     :ressourceHeader="ressource"
                                     :fiche="fiche"
                                     :objet-metier=selectedObjetMetier
                                     :route="route"
                                     :attribut="attribut"
                                     @extended="setExtended"
                                     @fullscreen="setFullscreen"
                                     @status="updateStatus"
                                     @toggleCardView="toggleCardView"
                                     @updated="objetMetierUpdated"
                                     @selectItem = "selectItem">
          </section-objet-metier-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import ObjetMetier from '@/extend/classes/ObjetMetier';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionObjetMetierList from '@/extend/sections/SectionObjetMetierListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionObjetMetierList,
    FicheHeader,
  },

  props: {
    objetMetier: {
      type: Object as PropType<ObjetMetier>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.OBJET_METIER,
      sections: [
        'OBJET_METIER_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_OBJET_METIER);
    },

    selectedObjetMetier (): ObjetMetier {
      return this.objetMetier
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    objetMetierUpdated (objetMetier: ObjetMetier) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.objetMetier || this.objetMetier.id < 0) && value == 'OBJET_METIER_LIST') {
        this.setExtended(new Extended('OBJET_METIER_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
